module.exports = __webpack_public_path__ + "static/hero-slide1-1dff4a3402ae8caed73f82d48c7a077b.mp4";